import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, MailCheck, ClipboardCheck, LogIn } from 'lucide-react';
import PublicShell, { PublicShellStatus } from './public/PublicShell';
import { REGISTRATION_STEPS } from './public/registrationSteps';
import './RegistrationSuccess.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const RegistrationSuccess = () => {
    const { eventNameId } = useParams();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchEvent = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/public/events/${eventNameId}`);
                setEvent(response.data);
            } catch (err) {
                setError('Event not found');
            } finally {
                setLoading(false);
            }
        };

        if (eventNameId) {
            fetchEvent();
        }
    }, [eventNameId]);

    if (loading) {
        return <PublicShellStatus><span className="pshell-spinner" aria-hidden="true" /> Loading…</PublicShellStatus>;
    }

    if (error || !event) {
        return <PublicShellStatus error>Event not found</PublicShellStatus>;
    }

    return (
        <PublicShell
            event={event}
            steps={REGISTRATION_STEPS}
            currentStep={3}
            stepsTitle="Registering takes a few minutes"
        >
            <div className="regsuccess">
                <span className="pshell-success-icon"><CheckCircle2 size={28} aria-hidden="true" /></span>
                <div className="pshell-eyebrow">Registration received</div>
                <h1 className="pshell-title">Thank you for registering</h1>
                <p className="pshell-subtitle">
                    Your registration for <strong>{event.Name}</strong> is in. Our team reviews every registration and will be in touch shortly.
                </p>

                <ol className="regsuccess-next">
                    <li>
                        <span className="regsuccess-next-icon"><ClipboardCheck size={16} aria-hidden="true" /></span>
                        <div>
                            <strong>We review your details</strong>
                            <span>This usually takes a few business days.</span>
                        </div>
                    </li>
                    <li>
                        <span className="regsuccess-next-icon"><MailCheck size={16} aria-hidden="true" /></span>
                        <div>
                            <strong>You get a confirmation email</strong>
                            <span>We’ll email you as soon as your registration is approved.</span>
                        </div>
                    </li>
                    <li>
                        <span className="regsuccess-next-icon"><LogIn size={16} aria-hidden="true" /></span>
                        <div>
                            <strong>Sign in and complete your profile</strong>
                            <span>Once approved, sign in with your email to finish setting up.</span>
                        </div>
                    </li>
                </ol>

                <div className="pshell-actions stack">
                    <Link to={`/login?event=${encodeURIComponent(eventNameId)}`} className="pshell-btn secondary block">Go to sign in</Link>
                </div>
            </div>
        </PublicShell>
    );
};

export default RegistrationSuccess;
